import type { Letter } from "../../../types";

/** Absolute positions can move without changing a rhèse's letter subtree. */
export function sameTextAppearance(previous: readonly Letter[], next: readonly Letter[]): boolean {
  if (previous === next) return true;
  if (previous.length !== next.length) return false;
  return previous.every((a, index) => {
    const b = next[index];
    const aKinds = a.kind, bKinds = b.kind;
    return a === b || (
      a.char === b.char && a.position === b.position && a.id === b.id &&
      a.isMute === b.isMute && a.phoneme === b.phoneme &&
      a.customColoration === b.customColoration && a.cssClasses === b.cssClasses &&
      (a.syllableId != null) === (b.syllableId != null) &&
      (aKinds === bKinds || (!!aKinds && !!bKinds && aKinds.length === bKinds.length &&
        aKinds.every((kind, i) => kind === bKinds[i])))
    );
  });
}
